import { AppColors } from "@/styles/colors";
import { ReactNode } from "react";
import { Card, Flex, Text } from "@chakra-ui/react";

interface Props {
  previewBody: ReactNode;
}

export const NotificationBodyPreviewCard = ({ previewBody }: Props) => {
  return (
    <Card.Root
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="8px"
    >
      <Card.Body paddingX="20px" paddingY="10px">
        <Flex flexDir="column" gap="8px">
          <Text
            fontWeight={600}
            color={AppColors.LIGHT_GRAY_TEXT}
            fontStyle={"italic"}
          >
            Vista previa:
          </Text>
          <Text fontWeight={600} color={AppColors.GRAY_BG}>
            {previewBody}
          </Text>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
